<template>
  <form>
    <div class="icon-wrap">
      <fa :icon="['fas','filter']" />
    </div>
    <div class="form-group nop nom">
      <input-control 
        label="Código Voucher" 
        placeholder="NCE262340" 
        cssClass="small" 
        name="codigoVoucher"
        v-model="filter.codigoVoucher"
      />
    </div>
    <div class="form-group nop nom">
      <input-control 
        label="Vencimento Inicial" 
        type="date" 
        cssClass="small"
        name="vencimentoInicial"
        v-model="filter.vencimentoInicial"
      />
      <input-control 
        label="Vencimento Final" 
        type="date" 
        cssClass="small"
        name="vencimentoFinal"
        v-model="filter.vencimentoFinal"
      />
    </div>
    <div class="form-group nop nom">
      <select-control 
        label="Status" 
        placeholder="Selecione" 
        :options="options.status" 
        cssClass="small"
        name="status"
        v-model="filter.status"
      />
    </div>
    <div>
      <a href="#" class="btn btn-primary btn-small" @click.prevent="runFilter()">Filtrar</a>
      <a href="#" class="btn btn-secondary btn-small" @click.prevent="clearFilter()">Limpar</a>
    </div>
  </form>
</template>

<script>
export default {
  data () {
    return {
      filter: {
        codigoVoucher: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        status: null
      },
      options: {
        status: [
          { label: 'Pendente', value: 0 },
          { label: 'Utilizado', value: 1 }
        ]
      }
    }
  },
  methods: {
    runFilter () {
      this.$emit('onFilter', this.filter)
    },
    clearFilter () {
      this.filter = {
        codigoVoucher: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        status: null
      }
      this.$emit('onClear')
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    width: 100%;
    display: flex;
    align-items: flex-end;
    gap: $hmg_mid;
    padding: $hmg_mid;
    // border-top: $border-component; 
    margin-top: $mg;

    >div {
      display: flex;
      align-items: center;
      gap: $mg_mini;

      &.icon-wrap {
        padding-bottom: $mg_mini
      }

      a {
        margin-bottom: 1px;
      }
    }
  }
</style>